import { useEffect } from 'react';

const SITE = 'https://hippocrate.mg';

/**
 * Injecte dynamiquement les balises SEO (title, description, canonical, Open Graph)
 * et un bloc JSON-LD pour les pages publiques du blog.
 * Nettoie le JSON-LD au démontage.
 */
export const BlogSeo = ({ title, description, path, image, jsonLd }) => {
  useEffect(() => {
    const url = `${SITE}${path || ''}`;
    const prevTitle = document.title;
    if (title) document.title = title;

    const set = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el && value != null) el.setAttribute(attr, value);
    };
    set('meta[name="description"]', 'content', description);
    set('meta[property="og:title"]', 'content', title);
    set('meta[property="og:description"]', 'content', description);
    set('meta[property="og:url"]', 'content', url);
    set('meta[property="og:type"]', 'content', 'article');
    set('meta[name="twitter:title"]', 'content', title);
    set('meta[name="twitter:description"]', 'content', description);
    if (image) {
      set('meta[property="og:image"]', 'content', image);
      set('meta[name="twitter:image"]', 'content', image);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', url);

    let script = null;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'blog-jsonld';
      script.text = JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd]);
      document.getElementById('blog-jsonld')?.remove();
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
      set('meta[property="og:type"]', 'content', 'website');
      document.getElementById('blog-jsonld')?.remove();
    };
  }, [title, description, path, image, jsonLd]);

  return null;
};

export default BlogSeo;
